import { getCLS, getFID, getLCP, getTTFB, getFCP } from 'web-vitals'

const SumoLogger = require('sumo-logger');

const ErrorMessages = {
  logDetails: 'Error :: Make sure `logDetails` is not empty',
  logEndpoint: 'Error :: Make sure `logEndpoint` is a string and not empty'
}

const EnvType = {
  DEV: 'dev',
  STAGE: 'stage',
  PROD: 'prod',
  PREPROD: 'preprod',
  BETA: 'beta',
  QA: 'qa',
  FL: 'fl',
  ML: 'ml'
}

const LogLevels = {
  info: 'INFO',
  warn: 'WARNING',
  error: 'ERROR',
  general: 'GENERAL'
}

const HttpSourceUrls = {
  stage: 'https://endpoint4.collection.sumologic.com/receiver/v1/http/ZaVnC4dhaV3DycXLxvHCf2JXjKxZJ-Tk2FdnlOXZPwPADrpN16i37oQy7bfWxx2YDc41EPQBnd8RSwGdfG8UeIiINUvs5Jp-ChMeax5DXtYfzIZ6X3opKA==',
  prod: 'https://endpoint4.collection.sumologic.com/receiver/v1/http/ZaVnC4dhaV3w8oi1wqDGjFgM3RmsR8AShe5HGLw5yBgOLGc8PPNkSrSZWJyV3DCIhvfIva9jmLVwbj8_axPmEjVwZHTDkgKY_DiJ19jQUAxdI-1JcRffSQ=='
}

const VERSION = 'Version';
const FRONTEND_SERVICE = 'Frontend Service';
const STAGE = 'stage';
const CHROME = 'Chrome';
const FIREFOX = 'Firefox';
const OPERA = 'Opera';
const SAFARI = 'Safari';
const MICROSOFT_INTERNET_EXPLORER = 'Microsoft Internet Explorer'

function parseUserAgent() {
  let nAgt = navigator.userAgent;
  let browserName  = navigator.appName;
  let fullVersion  = ''+parseFloat(navigator.appVersion); 
  let majorVersion = parseInt(navigator.appVersion,10);
  let nameOffset,verOffset,ix;

  // Opera Browser
  if ((verOffset=nAgt.indexOf(OPERA))!=-1) {
  browserName = OPERA;
  fullVersion = nAgt.substring(verOffset+6);
  if ((verOffset=nAgt.indexOf(VERSION))!=-1) 
    fullVersion = nAgt.substring(verOffset+8);
  }
  // MISE
  else if ((verOffset=nAgt.indexOf("MSIE"))!=-1) {
  browserName = MICROSOFT_INTERNET_EXPLORER;
  fullVersion = nAgt.substring(verOffset+5);
  }
  // Chrome
  else if ((verOffset=nAgt.indexOf(CHROME))!=-1) {
  browserName = CHROME;
  fullVersion = nAgt.substring(verOffset+7);
  }
  // Safari
  else if ((verOffset=nAgt.indexOf(SAFARI))!=-1) {
  browserName = SAFARI;
  fullVersion = nAgt.substring(verOffset+7);
  if ((verOffset=nAgt.indexOf(VERSION))!=-1) 
    fullVersion = nAgt.substring(verOffset+8);
  }
  // Firefox
  else if ((verOffset=nAgt.indexOf(FIREFOX))!=-1) {
  browserName = FIREFOX;
  fullVersion = nAgt.substring(verOffset+8);
  }
  // Others
  else if ( (nameOffset=nAgt.lastIndexOf(' ')+1) < 
            (verOffset=nAgt.lastIndexOf('/')) ) 
  {
  browserName = nAgt.substring(nameOffset,verOffset);
  fullVersion = nAgt.substring(verOffset+1);
  if (browserName.toLowerCase()==browserName.toUpperCase()) {
    browserName = navigator.appName;
  }
  }
  // trim the fullVersion string at semicolon/space if present
  if ((ix=fullVersion.indexOf(";"))!=-1)
    fullVersion=fullVersion.substring(0,ix);
  if ((ix=fullVersion.indexOf(" "))!=-1)
    fullVersion=fullVersion.substring(0,ix);

  majorVersion = parseInt(''+fullVersion,10);
  if (isNaN(majorVersion)) {
  fullVersion  = ''+parseFloat(navigator.appVersion); 
  majorVersion = parseInt(navigator.appVersion,10);
  }

  return {
    appName: navigator.appName,
    browserName: browserName,
    fullVersion: fullVersion,
    majorVersion: majorVersion,
    userAgent: navigator.userAgent
  }
}

function detectEnv(clientUrl) {
  if (clientUrl.includes(EnvType.DEV)) {
    return EnvType.DEV
  } else if (
    clientUrl.includes(EnvType.STAGE) ||
    clientUrl.includes(EnvType.PREPROD) ||
    clientUrl.includes(EnvType.QA) ||
    clientUrl.includes(EnvType.BETA) ||
    clientUrl.includes(EnvType.FL) ||
    clientUrl.includes(EnvType.ML)
    ) {
    return EnvType.STAGE
  }
  return EnvType.PROD
}

function sendLog({
  clientUrl,
  logDetails,
  logEndpoint,
  logLevel,
  serviceName = FRONTEND_SERVICE,
}) {
  const envType = detectEnv(window.location.origin);

  if (typeof logDetails === 'object' && logDetails === {} || !logDetails) {
    throw Error(ErrorMessages.logDetails);
  }

  if (envType === EnvType.DEV) {
    switch (logLevel.toLowerCase()) {
      case 'info':
        console.info(`%c LOCAL_LOGGER::${LogLevels.info}`,
          "color:#047857; background-color:#bbf7d0; padding:2px; font-size:10px",
          logDetails
        );
        break;
      case 'warn':
        console.warn(`%c LOCAL_LOGGER::${LogLevels.warn}`,
          "color:#c2410c; background-color:#fed7aa; padding:2px; font-size:10px",
          logDetails
        );
        break;
      case 'error':
        console.warn(`%c LOCAL_LOGGER::${LogLevels.error}`,
          "color:#b91c1c; background-color:#fecaca; padding:2px; font-size:10px",
          logDetails
        );
        break;
      default:
        console.log(`%c LOCAL_LOGGER::${LogLevels.general}`,
          "color:#a16207; background-color:#fef08a; padding:2px; font-size:10px",
          logDetails
        );
    }
  } else {
    const options = {
      interval: 30000,
      batchSize: 1048576,
      endpoint: logEndpoint ? logEndpoint : envType === STAGE ? HttpSourceUrls.stage : HttpSourceUrls.prod,
      clientUrl: clientUrl || window.location,
    };

    const sumoLogger = new SumoLogger(options);
    const userAgentDetails = parseUserAgent();
    const logInfo = {
      frontendService: `${serviceName} - ${envType.toUpperCase()}`,
      logDetails: logDetails,
      logType: logLevel,
      ...userAgentDetails
    };

    sumoLogger.log(logInfo);
  }
}

function sendWebVitalsToSum(metrics) {
  sendLog({
    logDetails: metrics,
    logLevel: 'INFO',
  })
}

function sendPerformanceLog() {
  getCLS(sendWebVitalsToSum);
  getFID(sendWebVitalsToSum);
  getFCP(sendWebVitalsToSum);
  getLCP(sendWebVitalsToSum);
  getTTFB(sendWebVitalsToSum);
}

export { sendLog, sendPerformanceLog };